export const paketWisata = [
  {
    id: 1,
    namePaket: "Ekowisata 1",
    content: "Mari lakukan penjelajahan bersama kami di Pulau Gili Iyang maka anda akan mendapatkan berbagai hal menarik",
    image_path: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_oleh_1: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_oleh_2: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_oleh_3: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_oleh_4: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_others: [
      "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
      "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
      "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    ],
  },
  {
    id: 2,
    namePaket: "Ekowisata 2",
    content: "Mari lakukan penjelajahan bersama kami di Pulau Gili Iyang maka anda akan mendapatkan berbagai hal menarik",
    image_path: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949995/banraas%2C%20gili-iyang/wisataalam2_lvyigr.png",
    image_oleh_1: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_oleh_2: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_oleh_3: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_oleh_4: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_others: [
      "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
      "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
      "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    ],
  },
  {
    id: 3,
    namePaket: "Ekowisata 3",
    content: "Mari lakukan penjelajahan bersama kami di Pulau Gili Iyang maka anda akan mendapatkan berbagai hal menarik",
    image_path: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675946981/banraas%2C%20gili-iyang/IMG20190819074642_utrsod.jpg",
    image_oleh_1: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_oleh_2: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_oleh_3: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_oleh_4: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_others: [
      "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
      "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
      "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    ],
  },
  {
    id: 4,
    namePaket: "Ekowisata 4",
    content: "Mari lakukan penjelajahan bersama kami di Pulau Gili Iyang maka anda akan mendapatkan berbagai hal menarik",
    image_path: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675945648/banraas%2C%20gili-iyang/Rectangle_33_qpdhv5.png",
    image_oleh_1: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_oleh_2: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_oleh_3: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_oleh_4: "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    image_others: [
      "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
      "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
      "https://res.cloudinary.com/dkltotiq0/image/upload/v1675949999/banraas%2C%20gili-iyang/wisataalam_dp8zet.png",
    ],
  },
];
